// import { useSettings } from '@/store/user';
import router from '@/router';

export default {
  data() {
    return {
      refreshing: false,
      registration: null,
      updateExists: false,
    }
  },  
  created() {
      this.user.isAuthenticated = false;  
      
      document.addEventListener('swUpdated', this.updateAvailable, { once: true })
  
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (this.refreshing) return
        this.refreshing = true
        window.location.reload()

      })
    },
  methods: {
      updateAvailable(event) {
        console.log('we caught the swUpdated event');

        this.registration = event.detail
        this.user.updateExists = true
        
        if(this.user.isAuthenticated == false) {
          this.refreshApp();
        } 
      },
  
      refreshApp() {
        if (!this.registration || !this.registration.waiting) return
        this.user.updateExists = false;
        
        this.registration.waiting.postMessage({ type: 'SKIP_WAITING' })

        router.replace('/');
      },
    },
  }